import capitalizeFirstLetter from "../../../utils/capitalizeFirstLetter";
import styles from "./TrackItem.module.css";

const TrackItem = (props) => {
  return <p className={styles.track}>{capitalizeFirstLetter(props.track)}</p>;
};

export default TrackItem;
